import { usePermissions } from '@anytag/auth';
import { useGetUserPermissionsQuery } from '@anytag/graphql';

export const useLoggedInUserPermissions = () => {
  const { dispatchPermissions, canCallCustomPermissions, permissions } = usePermissions();
  const { data, loading } = useGetUserPermissionsQuery({
    fetchPolicy: 'cache-and-network',
    skip: !canCallCustomPermissions || !!permissions,
    onCompleted: ({ getUserPermissions }) => {
      dispatchPermissions(getUserPermissions?.permissions || null);
    }
  });

  return {
    permissionLoading: loading,
    permissions: permissions || data?.getUserPermissions?.permissions || null
  };
};
